

export const lightMode = () => {
  const light = {
    REDCOLOR: "#ea1c26",
    TEXTCOLOR: "#8a8a8a",
    TEXTCOLOR1:"#000",
    BORDERSCOLOR: "#eee",
    WHITECOLOR: "#ffffff",
    BLACKCOLOR: "#000",
    GRAYCOLOR: "#f6f7f8",
    BACKGROUND1:"#ffffff",
    FAKEWHITE : "#ffffff",
    FAKEGRAY : "#f6f7f8",
    BORDERINPUT: "#1773b0"
  };

  return light;
};

export const darkMode = () => {
  const dark = {
    REDCOLOR: "#ea1c26",
    TEXTCOLOR: "#f6f7f8",
    BORDERSCOLOR: "#ea1c26",
    WHITECOLOR: "#ffffff",
    BLACKCOLOR: "#000",
    GRAYCOLOR: "#33373e",
    BACKGROUND1:"#20232a",
    FAKEWHITE : "#33373e",
    FAKEGRAY: "#000",
    TEXTCOLOR1:"#FFF",
    BORDERINPUT: "#1773b0"
  };

  return dark;
};
